function SmartIdLogin() {
  var self = this;

  function initSmartIdDialog() {
    $('#smart-id-personal-code').focus()
  }

  function retry(success, failure) {
    Fetch.post('/login/smart-id-complete')
      .then(function (response) {
        if (response.retry) {
          setTimeout(function () {
            retry(success, failure)
          }, 1000);
        }
        else {
          success(response);
        }
      }, failure);
  }

  function startAuthenticating() {
    hideLoginError()
    $('#smart-id-submit').attr('disabled', true)

    Fetch.post('/login/smart-id', {
      nationalIdentityNumber: $('#smart-id-personal-code').val()
    }).then(function (result) {
      $('#smart-id-challenge-container').removeAttr('hidden')
      $('#smart-id-challenge').text(result.challenge)
      return new Promise(function (success, failure) {
        retry(success, failure)
      });
    }).then(loginSuccess)
      .catch(loginFailure)
  }

  function loginSuccess(response) {
    $('#smart-id-challenge-container').attr('hidden', 'hidden')
    $('#loginModal').modal('hide')
    window.session = new Session(response.user, response.authType)
    $('#login-link').hide()
    location.href = '#loading'
  }

  function loginFailure(response) {
    $('#smart-id-challenge-container').attr('hidden', 'hidden')
    $('#smart-id-submit').attr('disabled', false)
    if (response.status === 412) {
      $('#loginModal').modal('hide')
      $('#underAge').collapse('show')
    }
    else {
      $('#loginFailed').removeAttr('hidden').find('#reason').text('')
    }
  }

  function hideLoginError() {
    $('#loginFailed').attr('hidden', 'hidden')
  }

  function onSubmit(event) {
    if (event.which === 13) {
      event.preventDefault();
      startAuthenticating()
    }
  }

  self.init = function () {
    var body = $('body')

    body.on('shown.bs.tab', '#loginModal #login-tab-smart-id', initSmartIdDialog)
    body.on('click', '#smart-id-submit', startAuthenticating)
    body.on('keyup', '#smart-id-personal-code', onSubmit)

    $('#loginModal').on('shown.bs.modal', function () {
      $('#smart-id-personal-code').focus();
    })

  }
}